import { gql } from '@apollo/client';
import { surfaceUnionFragment } from 'graphql/surface-node/fragments/surface-node-fragment/surface-node-union-fragment';

export const surfaceNodesLinkedSubscription = gql`
  subscription surfaceNodesLinked($surface: ID!, $user: ID!) {
    surfaceNodesLinked(surface: $surface, user: $user) {
      node {
        ...surfaceNodeUnionDetails
      }
      user
    }
  }
  ${surfaceUnionFragment}
`;
